<template>
  <div class="recent-search">
    <div class="title">
      <span>{{ $t("recentSearches") }}</span>
      <img :src="deleteHistoryImg" @click="onDelete" alt="" />
    </div>
    <div class="search-history-keys">
      <div
        class="search-history-key-item"
        v-for="key in searchHistoryKeys"
        :key="key"
        @click="onSearchHistoryKey(key)"
      >
        <span v-if="key.length <= 6">{{ key }}</span>
        <span v-else-if="key">{{
          key.slice(0, 3) + "..." + key.slice(-3)
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchHistoryKeys: {
      type: Array
    }
  },
  computed: {
    deleteHistoryImg() {
      return require(`../../assets/common/delete${this.darkModeImg}.png`);
    }
  },
  methods: {
    onDelete() {
      this.$emit("delete");
    },
    onSearchHistoryKey(key) {
      this.$emit("key", key);
    }
  }
};
</script>

<style lang="less" scoped>
.recent-search {
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 16px;
      color: var(--color-29);
      font-weight: 600;
    }
    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .search-history-keys {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    .search-history-key-item {
      height: 32px;
      line-height: 32px;
      // background: var(--bg-36);
      border: 1px solid var(--border-25);
      border-radius: 8px;
      padding: 0 16px;
      font-size: 13px;
      color: var(--color-29);
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 680px) {
  .recent-search {
    .title {
      span {
        font-size: 14px;
      }
    }
    .search-history-keys {
      .search-history-key-item {
        height: 29px;
        line-height: 29px;
        padding: 0 12px;
        font-size: 11px;
      }
    }
  }
}
</style>
